// extracted by mini-css-extract-plugin
export var container = "parking-detail-info-table-module--container---aPS0";